import * as React from "react";
const CloneArrows: React.FC<{ className?: string }> = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      className={className}
      d="M5.61523 15.1924L2.42332 12.0005L5.61523 8.80859"
      stroke="#21394F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.42649 12.0012H9.87429"
      stroke="#21394F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3848 8.80859L21.5767 12.0005L18.3848 15.1924"
      stroke="#21394F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.5735 12.0012H14.1257"
      stroke="#21394F"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CloneArrows;
